import { render, staticRenderFns } from "./NextMoveStartDescription.vue?vue&type=template&id=30b3b8cd&scoped=true"
import script from "./NextMoveStartDescription.vue?vue&type=script&lang=ts"
export * from "./NextMoveStartDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3b8cd",
  null
  
)

export default component.exports